import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

const apiGetListTimeServicesAtOfficeByTrans = `${host}admin/exportJSON/averageOfficeTimeByService`

export const getListTimeServicesAtOfficeByTrans = ({
    FromDate,
    ToDate,
    BranchIDs,
    ServiceCode,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ServiceCode,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListTimeServicesAtOfficeByTrans,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_TIME_SERVICES_AT_OFFICE_BY_TRANS,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ServiceCode,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
    } catch (err) {
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_TIME_SERVICES_AT_OFFICE_BY_TRANS_ERROR,
            () => false
        )
    }
}

export const exportListTimeServicesAtOfficeByTrans = ({
    FromDate,
    ToDate,
    BranchIDs,
    ServiceCode,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ServiceCode,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListTimeServicesAtOfficeByTrans,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${BranchCodes.join('-')}`
            )
        }
    } catch (err) {
        console.log(err)
    }
}
